import DataGridComponent from 'components/DataGrid/DataGridComponent';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BarrierTypeMappingForm from './BarrierTypeMappingForm';
import { APIEndpoints } from 'helpers/APILists';
import {
    barrierTypeMappingHeaderData,
    barrierTypeMappingApiEndpoint,
    barrierTypeMappingInitialState, barrierTypeMappingSearchState
} from './BarrierTypeMapping.data';
import { trackErrors } from '../helper';
import { MESSAGE_TYPE } from 'journeys/common/common.constants';
import { AdminConstants } from '../../AdminScreen.constants';

const addTitle = 'Add New Record for Barrier Type Mapping';
const editTitle = 'Edit Record for BP Barrier Type Mapping';

const BarrierTypeMapping = () => {
    const apiEndpoints = barrierTypeMappingApiEndpoint;
    const [showModal, setShowModal] = useState(false);
    const [editRowData, setEditRowData] = useState(barrierTypeMappingInitialState);
    const [modalTitle, setModalTitle] = useState(addTitle);
    const [refreshDatagrid, setRefreshDatagrid] = useState(false);
    const [regionTypeOptions, setRegionTypeOptions] = useState([]);
    const [workTypeOptions, setWorkTypeOptions] = useState([]);
    const [rowDetails, setRowDetails] = useState({
        columnName: 'RowId',
        rowNumber: ''
    });

    const fetchRegionTypeOptions = () => {
        axios.get(APIEndpoints.ADMIN_GetRegionTypeLkup)
            .then(res => {
                const filtered = res.data
                    .filter(y => y.Status === AdminConstants.ACTIVE)
                    .map(x => ({ RowId: x.RowId, RegionType: x.RegionType }));
                setRegionTypeOptions(filtered);
            })
            .catch(err => {
                trackErrors({
                    messageType: MESSAGE_TYPE.ERROR,
                    message: err.message,
                    exception: err
                });
            });
    };
    const fetchWorkTypeOptions = () => {
        axios.get(APIEndpoints.ADMIN_GetWorkTypeLkup)
            .then(res => {
                const filtered = res.data
                    .filter(y => y.Status === AdminConstants.ACTIVE);
                setWorkTypeOptions(
                    filtered.map(x => ({
                        RowId: x.RowId,
                        WorkType: x.WorkType,
                        WorkTypeCode: x.WorkTypeCode
                    }))
                );
            })
            .catch(err => {
                trackErrors({
                    messageType: MESSAGE_TYPE.ERROR,
                    message: err.message,
                    exception: err
                });
            });
    };

    useEffect(() => {
        fetchRegionTypeOptions();
        fetchWorkTypeOptions();
    }, []);

    const parseData = async (data) => {
        try {
            return data.map(item => ({
                ...item,
                DefaultBarrierType: item.DefaultBarrierType ? 'Yes' : 'No'
            }));
        } catch (err) {
            trackErrors({
                messageType: MESSAGE_TYPE.ERROR,
                message: err.message,
                exception: err
            });
            throw err;
        }
    };

    const handleEditRecord = (obj) => {
        const rowData = obj.row;
        setModalTitle(editTitle);
        setShowModal(true);
        setEditRowData((prev) => ({
            ...prev,
            ...rowData
        }));
    };
    const handleAddRecord = () => {
        setEditRowData(barrierTypeMappingInitialState);
        setModalTitle(addTitle);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleRecordSubmit = (newId) => {
        setRefreshDatagrid(prev => !prev);
        setRowDetails(prev => ({ ...prev, rowNumber: newId }));
    };

    return (
        <>
            <DataGridComponent
                headerData={barrierTypeMappingHeaderData}
                apiEndpoint={apiEndpoints.read}
                editRecord={handleEditRecord}
                addRecord={handleAddRecord}
                rowDetails={rowDetails}
                dataParser={parseData}
                initialData={barrierTypeMappingSearchState}
                refreshDatagrid={refreshDatagrid}
            />

            {showModal
                && (
                    <BarrierTypeMappingForm
                        isOpen={showModal}
                        onClose={handleModalClose}
                        title={modalTitle}
                        rowData={editRowData}
                        onRecordSubmit={handleRecordSubmit}
                        regionTypeOptions={regionTypeOptions}
                        workTypeOptions={workTypeOptions}
                    />
                )}
        </>
    );
};

export default BarrierTypeMapping;
